import { useEffect, useState } from 'react';
import styled from 'styled-components';
import InputText, { InputTextProps } from '../atoms/input/InputText';
import { OptionType } from '../atoms/Picklist';

type InputSearchProps<T> = InputTextProps & {
  options?: T[] | OptionType[];
  renderOption?: (option: T | OptionType) => React.ReactNode;
  onOptionClick?: (option: T | OptionType) => void;
};
const InputSearch = <T extends any>(props: InputSearchProps<T>) => {
  const [value, setValue] = useState('');
  const [finish, setFinish] = useState(false);
  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);
  return (
    <Container className={props.className}>
      <InputText
        {...props}
        className=""
        onChange={(v) => {
          setValue(v);
          props.onChange && props.onChange(v);
          setFinish(false);
        }}
        onEscapePressed={() => {
          setFinish(true);
        }}
        value={value}
        smallPadding={true}
      ></InputText>
      {!finish && props.options && props.options.length > 0 && (
        <FloatWrapper>
          {props.options.map((it: OptionType | T, i) => {
            return props.renderOption ? (
              <div
                onClick={() => {
                  setFinish(true);
                  props.onOptionClick && props.onOptionClick(it);
                }}
              >
                {props.renderOption(it)}
              </div>
            ) : (
              <div
                className="option"
                key={(it as OptionType).value}
                onClick={() => {
                  setValue((it as OptionType).label);
                  props.onChange && props.onChange((it as OptionType).label);
                  setFinish(true);
                }}
              >
                {(it as OptionType).label}
              </div>
            );
          })}
        </FloatWrapper>
      )}
    </Container>
  );
};
const Container = styled.div`
  position: relative;
`;
const FloatWrapper = styled.div`
  background: white;
  border: 1px solid var(--color-gray, #a0a0a0);
  border-radius: 0px 0px 4px 4px;
  z-index: 0;
  margin-top: -2px;
  position: absolute;
  overflow-y: scroll;
  max-height: 200px;
  width: calc(100% - 2px);
  div.option {
    padding: 12px;
    font-family: 'Noto Sans JP';
    font-size: 16px;
    font-weight: 400;
    line-height: 1.75;
    letter-spacing: 0.04em;
    text-align: left;
    color: var(--color-placeholder, #969696);
  }
  div.option:hover {
    color: var(--color-black, #000);
  }
`;
export default InputSearch;
